import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { MultisiteDashboardUserSettingsQueryKey } from './keys';
import { getMultisiteDashboardUserSettingsQueryKey } from './keys';
import type {
  MultisiteDashboardUserSettingsData,
  UseMultisiteDashboardUserSettingsParams,
} from './types';

export const useMultisiteDashboardUserSettings: QueryFunction<
  MultisiteDashboardUserSettingsData,
  [UseMultisiteDashboardUserSettingsParams],
  MultisiteDashboardUserSettingsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const { userId } = params;
  const queryKey = getMultisiteDashboardUserSettingsQueryKey(params);
  const request = useRequest(requestOptions);

  const enabled = queryOptions?.enabled !== false && !!userId;

  return useQuery({
    ...queryOptions,
    enabled,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/users/${params.userId}/multisite_dashboard_user_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
